// extracted by mini-css-extract-plugin
export var footer = "menuFooter-module--footer--1X3HU";
export var linkedin = "menuFooter-module--linkedin--SJj+6";
export var linkedinLink = "menuFooter-module--linkedinLink--OsLEr";
export var mail = "menuFooter-module--mail--eJnTK";
export var mailLink = "menuFooter-module--mailLink--ysveM";